export default __webpack_public_path__ + "static/media/categories.b5876213.webp";